import { Resource } from "../types/resources";

export const mockResources: Resource[] = [
  {
    id: "1",
    title: "The ultimate guide to Workplace Chat",
    topic: "Sample Topic",
    category: "Secure Base",
    type: "link",
    color: "#E00027",
  },
  {
    id: "2",
    title: "The ultimate guide to Workplace Chat",
    topic: "Sample Topic",
    category: "Secure Base",
    type: "video",
    color: "#17E4A1",
  },
  {
    id: "3",
    title: "The ultimate guide to Workplace Chat",
    topic: "Sample Topic",
    category: "Secure Base",
    type: "link",
    color: "#E00027",
  },
  {
    id: "4",
    title: "The ultimate guide to Workplace Chat",
    topic: "Sample Topic",
    category: "Wellbeing",
    type: "video",
    color: "#FF603E",
  },
  {
    id: "5",
    title: "The ultimate guide to Workplace chat",
    topic: "Sample Topic",
    category: "Secure Base",
    type: "pdf",
    color: "#FFE500",
  },
  {
    id: "6",
    title: "Taking stock of mental health in your workplace",
    topic: "Sample Topic",
    category: "Secure Base",
    type: "pdf",
    color: "#56CCF2",
  },
];
